module.exports = __webpack_public_path__ + "img/43_87.c96c7bdc.png";